export default __webpack_public_path__ + "static/media/59.f52e0286.png";